<div fxFlex="100" fxLayout="column" fxLayoutAlign="space-evenly stretch">
  <mat-card>
    <h2 translate>operationDetail.title</h2>
    <p translate>operationDetail.subtitle</p>

    <mat-card-content>
      <form [formGroup]="operationDetailForm" (ngSubmit)="searchDetails()">
        <div fxFlex fxLayout="row wrap" class="form-wrapper">
          <div fxFlex.gt-sm="50" *ngIf="isMacroChainUser || isBusinessDirector">
            <scf-custom-select-search
              fxFlex="100"
              formControlName="macroChain"
              [cucumberId]="'macroChain'"
              [id]="'macroChainSelect'"
              [dataInput]="macroChainList"
              [placeholder]="'macrouser.title.groups'"
              [isRequired]="true"
              [showErrors]="operationDetailForm?.controls?.macroChain?.errors"
            >
            </scf-custom-select-search>
          </div>
          <div fxFlex="100" fxFlex.gt-sm="50" *ngIf="isMacroOfficeUser || isBusinessDirector">
            <scf-custom-select-search
              fxFlex="100"
              formControlName="macroOffice"
              [cucumberId]="'macroOffice'"
              [id]="'macroOfficeSelect'"
              [dataInput]="macroOfficeList"
              [placeholder]="'macrouser.title.offices'"
              [isRequired]="true"
              [showErrors]="operationDetailForm?.controls?.macroOffice?.errors"
            >
            </scf-custom-select-search>
          </div>
          <div fxFlex="100" fxFlex.gt-sm="100" *ngIf="isMacroChainUser || isMacroOfficeUser"></div>
          <div fxFlex="50" fxFlex.gt-sm="30">
            <scf-custom-select-search
              fxFlex="100"
              formControlName="division"
              [cucumberId]="'division'"
              [id]="'divisionOperationDetail'"
              [dataInput]="divisionList"
              [placeholder]="'operationDetail.division'"
              [isRequired]="true"
              [showErrors]="operationDetailForm?.controls?.division?.errors"
            >
            </scf-custom-select-search>
          </div>
          <div fxFlex="50" fxFlex.gt-sm="35">
            <scf-custom-select-search
              fxFlex="100"
              formControlName="office"
              [cucumberId]="'office'"
              [id]="'officeOperationDetail'"
              [dataInput]="officeList"
              [placeholder]="'operationDetail.office'"
              [showErrors]="operationDetailForm?.controls?.office?.errors"
            >
            </scf-custom-select-search>
          </div>
          <div fxFlex="50" fxFlex.gt-sm="35">
            <scf-custom-select-search
              fxFlex="100"
              formControlName="status"
              [cucumberId]="'status'"
              [id]="'statusOperationDetail'"
              [dataInput]="statusList"
              [placeholder]="'operationDetail.state'"
              [showErrors]="operationDetailForm?.controls?.status?.errors"
            >
            </scf-custom-select-search>
          </div>
          <div fxFlex="50" fxFlex.gt-sm="30">
            <scf-custom-select-search
              fxFlex="100"
              formControlName="group"
              [cucumberId]="'chain'"
              [id]="'groupOperationDetail'"
              [dataInput]="groupList"
              [placeholder]="'operationDetail.group'"
              [showErrors]="operationDetailForm?.controls?.group?.errors"
            >
            </scf-custom-select-search>
          </div>

          <div fxFlex="50" fxFlex.gt-sm="35">
            <scf-custom-select-search
              fxFlex="100"
              formControlName="agent"
              [cucumberId]="'establishment'"
              [id]="'agentOperationDetail'"
              [dataInput]="agentList"
              [placeholder]="'operationDetail.agent'"
              [showErrors]="operationDetailForm?.controls?.agent?.errors"
            >
            </scf-custom-select-search>
          </div>

          <div fxFlex="50" fxFlex.gt-sm="35">
            <scf-custom-select-search
              fxFlex="100"
              formControlName="externalCommercial"
              [cucumberId]="'externalCommercial'"
              [id]="'externalCommercialOperationDetail'"
              [dataInput]="externalCommercialList"
              [placeholder]="'operationDetail.externalCommercial'"
              [showErrors]="operationDetailForm?.controls?.externalCommercial?.errors"
            >
            </scf-custom-select-search>
          </div>

          <div fxFlex="50" fxFlex.gt-sm="30">
            <scf-custom-select-search
              fxFlex="100"
              formControlName="origin"
              [cucumberId]="'origin'"
              [id]="'originOperationDetail'"
              [dataInput]="originList"
              [placeholder]="'operationDetail.origin'"
              [showErrors]="operationDetailForm?.controls?.origin?.errors"
            >
            </scf-custom-select-search>
          </div>

          <div fxFlex="50" fxFlex.gt-sm="35">
            <mat-form-field fxFlex="100" appearance="outline" monthYearFullDirective>
              <mat-label translate>operationDetail.startDate</mat-label>
              <input
                [attr.data-cucumber-id]="'initialDate'"
                id="startDateOperationDetail"
                matInput
                [matDatepicker]="datepickerStart"
                formControlName="startDate"
                [max]="maxDate"
                autocomplete="off"
              />
              <mat-datepicker-toggle matSuffix [for]="datepickerStart"></mat-datepicker-toggle>
              <mat-datepicker
                [attr.data-cucumber-id]="'initialDatePicker'"
                id="startDateOperationDetailDatePicker"
                #datepickerStart
                startView="multi-year"
                (monthSelected)="chosenMonthHandler($event, datepickerStart, 'startDate')"
                (yearSelected)="chosenYearHandler($event, 'startDate')"
              >
              </mat-datepicker>
              <mat-error *ngIf="operationDetailForm.controls.startDate.hasError('required')" translate>
                field.required
              </mat-error>
              <mat-error *ngIf="operationDetailForm.controls.startDate.hasError('dateFuture')" translate>
                field.error.dateFuture
              </mat-error>
              <mat-error *ngIf="operationDetailForm.errors?.dateInvalid" translate>field.error.dateInitial</mat-error>
            </mat-form-field>
          </div>

          <div fxFlex="50" fxFlex.gt-sm="35">
            <mat-form-field fxFlex="100" appearance="outline" monthYearFullDirective>
              <mat-label translate>operationDetail.endDate</mat-label>
              <input
                [attr.data-cucumber-id]="'finalDate'"
                id="endDateOperationDetail"
                matInput
                [matDatepicker]="datepickerEnd"
                formControlName="endDate"
                [min]="minDate"
                [max]="maxFinalDate"
                autocomplete="off"
              />
              <mat-datepicker-toggle matSuffix [for]="datepickerEnd"></mat-datepicker-toggle>
              <mat-datepicker
                [attr.data-cucumber-id]="'finalDatePicker'"
                id="endDateOperationDetailDatePicker"
                #datepickerEnd
                startView="multi-year"
                (monthSelected)="chosenMonthHandler($event, datepickerEnd, 'endDate')"
                (yearSelected)="chosenYearHandler($event, 'endDate')"
              >
              </mat-datepicker>
              <mat-error *ngIf="operationDetailForm.controls.endDate.hasError('required')" translate>
                field.required
              </mat-error>
              <mat-error *ngIf="operationDetailForm.controls.endDate.hasError('dateFuture')" translate>
                field.error.dateFuture
              </mat-error>
              <mat-error *ngIf="operationDetailForm.controls.endDate.hasError('matDatepickerMin')" translate
                >field.error.dateFinal</mat-error
              >
              <mat-error *ngIf="operationDetailForm.errors?.dateYearError" translate>field.notMoreThanAYear</mat-error>
            </mat-form-field>
          </div>

          <div fxFlex="100" fxFlex.gt-sm="100">
            <div class="search-operation-detail__button">
              <button
                id="searchButtonOperationDetail"
                mat-flat-button
                color="accent"
                type="submit"
                [disabled]="operationDetailForm.invalid"
              >
                <mat-label translate>operationDetail.consult</mat-label>
              </button>
            </div>
          </div>
        </div>
      </form>
    </mat-card-content>
  </mat-card>

  <mat-card *ngIf="hasNoOperation()">
    <div fxLayout="column" fxLayoutAlign="center center" class="invest-detail__card">
      <mat-label class="panel-request__label-no-operation" translate>controlPanel.noOperations</mat-label>
    </div>
  </mat-card>

  <app-requests-with-detalil-table
    fxFlex="100"
    *ngFor="let operations of requestOperationsList"
    [operations]="operations"
  >
  </app-requests-with-detalil-table>

  <div class="panel_footer__buttons" *ngIf="hasAnyOperation()">
    <div fxFlex="100" fxLayoutAlign="end start" fxLayoutGap="16px">
      <button id="createAllExcelOperationDetail" mat-stroked-button color="accent" (click)="createAllExcel()">
        <mat-icon class="icon-ic_file_download"></mat-icon>
        <span>{{ 'button.exportExcel' | translate | uppercase }}</span>
      </button>
      <button id="createAllPdfOperationDetail" mat-stroked-button color="accent" (click)="createAllPdf()">
        <mat-icon class="icon-ic_print"></mat-icon>
        <span>{{ 'button.print' | translate | uppercase }}</span>
      </button>
    </div>
  </div>
</div>
